import { groupBy } from 'lodash-es';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { DomainDataFacade } from '@mitsubishi/core';
import { Class } from '@mitsubishi/shared/data-access';

@Component({
  selector: 'apm-class-selection',
  templateUrl: './class-selection.component.html',
  styleUrls: ['./class-selection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ClassSelectionComponent {
  groupedClasses$: Observable<{ [key: string]: Class[] }>;
  custom = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: { class$: Observable<Class[]>; custom: boolean },
    private dialogRef: MatDialogRef<ClassSelectionComponent>,
    private commonDataFacade: DomainDataFacade
  ) {
    this.custom = data.custom;
    const classesObservable = data.class$ ? data.class$ : this.commonDataFacade.classes$;
    this.groupedClasses$ = classesObservable.pipe(
      map(classes => {
        return groupBy(classes, 'column');
      })
    );
  }

  filterSelected(selectedClass: Class) {
    this.dialogRef.close(selectedClass);
  }

  customSelected() {
    this.dialogRef.close({ custom: true, uta: false });
  }

  utaSelected() {
    this.dialogRef.close({ custom: true, uta: true });
  }
}
